/**
 * Sin badge de app ni título con contador por eventos de mensaje (no-op).
 */

const DEFAULT_TITLE = 'ArChat';

export function setBadge() {}

export function updateBadge() {
  try {
    document.title = DEFAULT_TITLE;
  } catch (_) {}
}
